<!--
 * @Author: Phoenix
 * @Date: 2020-02-12 16:48:28
 * @LastEditTime: 2020-07-08 10:38:02
 * @Description: 用于展示多条结构类似的数据，可对数据进行排序、筛选、对比或其他自定义操作。
 * @FilePath: \ups-single-window-web\src\components\CommonTable\index.vue
 * @未经本人许可，任何单位及个人不得以任何方式对本产品进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
-->

<template>
  <div>
    <el-table v-ht="{headHeight, fixHeaght: config.fixHeaght}" :data="tableData" :stripe="config.stripe" :size="config.size" :border="config.border"
      :header-cell-style="config.headStyle" :row-style="config.rowStyle" :height="config.height"
      :highlight-current-row="config.highlightCurrentRow"
      :empty-text="config.emptyText" class="commmon-table" @row-click="config.rowClick"
      @selection-change="config.selectionChange"
    >

      <el-table-column v-if="config.multipleRowSelect" :key="renderKey" type="selection" width="60"></el-table-column>
      <el-table-column v-if="config.index" :key="renderKey1" label="序号" type="index" :index="indexMethod" width="100"></el-table-column>
      <el-table-column v-for="(column, index) in columns.filter(item => item)" :key="index" :prop="column.prop" :type="column.type" :label="column.label"
        :align="getAlign(column)" :width="column.width">
        <template #default="scope">
          <my-render v-if="column.render" :row="scope.row" :cell-value="scope.row[column.prop]" :render="column.render" :row-index="scope.$index"></my-render>
          <div v-else>
            {{ scope.row[column.prop] }}
            <span v-if="column.subProp" class="subProp">
              {{ scope.row[column.subProp] }}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="config.total && config.pagination" class="block">
      <el-pagination small :total="config.total" background
        layout="total, prev, pager, next, jumper" :current-page="config.page_index"
        :page-size="config.page_size" @current-change="config.currentChange" @size-change="config.sizeChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import { h } from 'vue'
export default {
  components: {
    'my-render': {
      functional: true,
      props: {
        cellValue: {
        },
        row: {
          type: Object
        },
        render: {
          type: Function
        },
        rowIndex: {
          type: Number
        }
      },
      render: (h, ctx) => {
        return ctx.props.render(h, ctx.props.row, ctx.props.cellValue, ctx.props.rowIndex)
      }
    }
  },
  directives: {
    ht: {
      updated(el, binding) {
        const headHeight = binding.value.headHeight
        const fixHeaght = binding.value.fixHeaght
        if (!fixHeaght) return
        if (headHeight === -1) {
          el.style.maxHeight = 'auto'
          return
        }
        if (headHeight === 0) {
          el.style.maxHeight = 'calc(100vh - 190px - ' + 100 + 'px)'
          el.style.overflow = 'auto'
          return
        }
        el.style.maxHeight = 'calc(100vh - 190px - ' + headHeight + 'px)'
        el.style.overflow = 'auto'
      }
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },

    options: {
      type: Object,
      default() {
        return {}
      }
    },
    headHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaultConfig: { // 默认配置
        fixHeaght: true, // 固定高度
        // table 属性
        size: 'mini', // 表格大小
        stripe: true, // 是否为斑马纹 table
        border: false, // 是否带有纵向边框
        highlightCurrentRow: false, // 是否要高亮当前行
        multipleRowSelect: false, // 是否支持表格行多选
        index: false, // 是否支持索引序列
        headStyle: {}, // 表头颜色
        rowStyle: {}, // 行的 style 的回调方法
        // commonStyle: { minHeight: '60vh' }, // table的样式
        // 分页
        pagination: true,
        page_size: 10,
        page_index: 0,
        total: 0,
        align: 'center',
        emptyText: '暂无数据', // 无数据提示
        /* 分页事件 */

        // 页码改变
        currentChange: (page) => { console.log(page) },

        // pagesize改变
        sizeChange: (size) => { console.log(size) },

        /*  表格事件  */

        // 单击表格行事件
        rowClick: (row, column, event) => {},

        //  当选择项发生变化时会触发该事件
        selectionChange: (selection) => { console.log(selection) },
        // 固定表头
        height: this.tableData.length ? '1000px' : '100%',
        // 是否需要控制勾选框的状态
        hasSelectable: false
      },
      renderKey: Math.random(),
      renderKey1: Math.random()
    }
  },
  computed: {
    config() {
      return Object.assign({}, this.defaultConfig, this.options) // 拿外部options覆盖默认配置
    },
    getAlign() {
      return (column) => {
        return column.align === 'left' ? 'left' : this.config.align
      }
    },
    indexMethod(index) {
      return 50 * this.config.page_index + 1
    }
  },
  watch: {
    'config.page_index': {
      deep: true,
      handler: function(newVal, val) {
        // console.log('config.page_index=>newVal:', newVal)
        // console.log('config.page_index=>val:', val)
      }
    },
    'page_index': {
      deep: true,
      handler: function(newVal, val) {
        // console.log('page_index=>newVal:', newVal)
        // console.log('page_index=>val:', val)
      }
    }
  },
  created() {
    // console.log('commonTable=>columns:', this.columns)
  },
  mounted() {
    this.renderKey = Math.random()
    this.renderKey1 = Math.random()
  },
  methods: {
    selectable(row) {
      if (!this.config.hasSelectable) return true
      return row.isSelectable
    }
  }
}
</script>

<style lang="scss">
.el-table .cell {
  white-space: normal !important; /* 允许换行 */
  word-break: break-word; /* 在长单词或URL地址内部进行换行 */
}

.block .el-pagination{
  margin-top: 30px;
  text-align: right;
}

.el-table__row .is-center .cell {
  display: flex;
  justify-content: center;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #E5EBF3;
}

.has-gutter .cell {
  color: #212121
}

.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  // background-color: #fff;
  // border: 1px solid #DCDFE6;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0662BB;
}
 .el-checkbox:last-of-type {
  margin-right: 0;
  margin-left: 20px;
}
.el-checkbox__inner::after {
  border: 1px solid #7191BE;
  border-top: 0;
  border-left: 0;
}

.el-table__empty-text {
  line-height: 60px;
  width: 50%;
  font-size: 14px;
  color: #909399;
}
.cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #666666;
}
.commmon-table.el-table::before {
  background-color:#fff !important;
}
</style>
